import axios from 'axios';
import {format_date, format_date_year, objectsAreEqual} from "../helpers";

export default {
  template: '#vue-cart',
  delimiters: ['${', '}'],
  props: {},
  data() {
    return {
      shipping: null,
      shipping_credit: null,

      cart_step: 'quantity',
      stock_error: false,
      changes_made: false,
      cart_stock: null,
      original_cart: null,
      initial_cart_token: null,
      clearance_items: {},
      final_sale_items: {},
      pre_order_items: {},

      cart_error: false,
      location_error: false,
      geocoding_error: false,
      outside_canada_error: false,
      routing_loading: false,
      routed_cart: [],
      pickup_shortcut: true,

      postal_code: null,
      postal_code_edit: false,
      custom_metadata: {}
    }
  },
  created() {
    this.$store.commit('registerComponent', {name: 'cart', component: this})
  },
  computed: {
    all_pickup() {
      for (let shipment of this.quantity_cart) {
        if (shipment.type === 'fulfillment') {
          return false
        }
      }
      return true
    },
    cart_tokens_set() {
      let valid = false
      let invalid = false
      for (let item of this.cart.items) {
        if (item.properties && item.properties._cart_token) {
          if (item.properties._cart_token === this.initial_cart_token) {
            valid = true
          } else {
            invalid = true
          }
        }
      }
      return {valid: valid, invalid: invalid}
    },
    has_invalid_quantities() {
      for (let shipment of this.quantity_cart) {
        for (let item of shipment.items) {
          if (item.available_quantity < item.quantity) {
            return true
          }
        }
      }
      return false
    },
    has_clearance_items() {
      for (let item of this.cart.items) {
        if (item.quantity > 0) {
          if (this.clearance_items[item.product_id]) {
            return true
          }
        }
      }
      return false
    },
    has_clearance_final_sale_items() {
      for (let item of this.cart.items) {
        if (item.quantity > 0) {
          if (this.clearance_items[item.product_id]) {
            return true
          }
          if (this.final_sale_items[item.product_id]) {
            return true
          }
        }
      }
      return false
    },
    quantity_cart() {
      let cart_stock = this.cart_stock || {variants: {}, stores: {}}

      // sort into pickup and ship object/array
      let pickup_items = {}
      let fulfillment_items = []
      this.cart.items.forEach(item => {
        if (item.properties && item.properties._store_for_pickup) {
          const store_number = parseInt(item.properties._store_for_pickup)
          if (!(store_number in pickup_items)) {
            pickup_items[store_number] = []
          }
          pickup_items[store_number].push(item)
        } else {
          fulfillment_items.push(item);
        }
      });

      // see how much of each UPC is being picked up at each store
      let pickup_leases = {}
      this.cart.items.forEach(item => {
        const pickup_store = parseInt((item.properties || {})._store_for_pickup) || null
        if (pickup_store) {
          const upc = parseInt(item.sku)
          if (!(upc in pickup_leases)) {
            pickup_leases[upc] = {}
          }
          pickup_leases[upc][pickup_store] = (pickup_leases[upc][pickup_store] || 0) + item.quantity
        }
      })

      // make sure pickup_leases do not exceed store stock
      for (let upc of Object.keys(pickup_leases)) {
        for (let store of Object.keys(pickup_leases[upc])) {
          const max_avail = (cart_stock.variants[upc] || {stock: {}}).stock[store] || 0
          if (pickup_leases[upc][store] > max_avail) {
            pickup_leases[upc][store] = max_avail
          }
        }
      }

      let pickup_shipments = []
      for (let pickup_store of Object.keys(pickup_items)) {
        pickup_shipments.push({
          type: 'pickup',
          store_info: this.$store.getters.store_info(pickup_store),
          items: pickup_items[pickup_store].map(i => {
            let item_out = Object.assign({}, i)
            item_out.price = this.$store.getters.currency(item_out.price);
            item_out.final_line_price = this.$store.getters.currency(item_out.quantity * item_out.original_price);

            const upc = parseInt(item_out.sku)

            let variant_info = cart_stock.variants[upc] || {stock: {}, shippable: false}
            item_out.available_quantity = variant_info.stock[pickup_store] || 0
            item_out.shippable_quantity = 0
            if (variant_info.shippable) {
              // shippable quantity is the sum of fulfillment stock,
              for (let stock_store of Object.keys(variant_info.stock)) {
                if (stock_store in cart_stock.stores && cart_stock.stores[stock_store].fulfillment) {
                  item_out.shippable_quantity += variant_info.stock[stock_store]
                  if (stock_store !== pickup_store && upc in pickup_leases && stock_store in pickup_leases[upc]) {
                    // minus any pickup leases at fulfillment stores OTHER than this one
                    item_out.shippable_quantity -= pickup_leases[upc][stock_store]
                  }
                }
              }
            }
            return item_out;
          })
        })
      }

      let fulfillment_shipments = []
      if (fulfillment_items.length > 0) {
        fulfillment_shipments.push({
          type: 'fulfillment',
          store_info: null,
          items: fulfillment_items.map(i => {
            let item_out = Object.assign({}, i)
            item_out.price = this.$store.getters.currency(item_out.price);
            item_out.final_line_price = this.$store.getters.currency(item_out.quantity * item_out.original_price);

            const upc = parseInt(item_out.sku)
            const variant = cart_stock.variants[upc] || {stock: {}, shippable: false}
            const leases = pickup_leases[upc] || {}

            item_out.available_quantity = 0
            item_out.pickup_nearby = false
            item_out.pickup_available = false
            if (variant.shippable) {
              for (let store of Object.keys(variant.stock)) {
                if (cart_stock.stores[store].fulfillment) {
                  // deduct ALL pickup leases from the max fulfill-able quantity
                  item_out.available_quantity += variant.stock[store] - (leases[store] || 0)
                }
                if (!cart_stock.stores[store].is_warehouse) {
                  if (cart_stock.stores[store].distance < 250) {
                    item_out.pickup_nearby = true
                  }
                  item_out.pickup_available = true
                }
              }
            }
            return item_out;
          })
        })
      }
      return pickup_shipments.concat(fulfillment_shipments)
    },
    total_quantities() {
      // Total quantities of each item - used for the 'X (Y Total)' labels
      let out = {}
      for (let item of this.cart.items) {
        if (item.variant_id in out) {
          out[item.variant_id] += item.quantity
        } else {
          out[item.variant_id] = item.quantity
        }
      }
      return out
    },
    render_cart() {
      // whether the cart page should be rendered, or a "Cart is Empty" label should be shown
      // We need to show this if the count is zero and there are pending changes in case the customer is trying
      // to remove the last item in their cart via the qty selectors and hasn't clicked apply yet
      return this.cart && (this.cart.item_count > 0 || (this.cart.item_count === 0 && this.changes_made && Object.keys(this.original_cart).length > 0))
    },
    cart() {
      // alias to vuex store
      return this.$store.state.cart
    },
    has_splits() {
      // whether to show the "items may ship from multiple locations" notice
      return this.routed_cart.filter(e => {
        return e.type === 'fulfillment'
      }).length > 1
    },
    subtotal() {
      let subtotal = 0.0
      this.cart.items.map(item => {
        subtotal += item.quantity * item.final_price
      })
      return subtotal
    },
    subtotal_money() {
      return this.$store.getters.currency(this.subtotal);
    },
    shipping_money() {
      return this.$store.getters.currency(this.shipping);
    },
    shipping_credit_money() {
      return this.$store.getters.currency(this.shipping_credit);
    },
    total() {
      return this.$store.getters.currency(this.subtotal + this.shipping - this.shipping_credit);
    }
  },
  methods: {
    format_date,
    format_date_year,
    check_pre_order_date(shipment) {
      let last_date = null
      for (let item of shipment.items) {
        if (item.product_id in this.pre_order_items) {
          last_date = last_date === null || this.pre_order_items[item.product_id] > last_date ? this.pre_order_items[item.product_id] : last_date
        }
      }
      return last_date
    },
    visible_item_properties(item) {
      let entries = Object.entries(item.properties)
      .filter(e => e[1] && !e[0].startsWith("_"))
      .map(e => [e[0].startsWith('custom_') ? e[0].substring(7) : e[0], e[1]])

      let out = {}
      let metadata = this.custom_metadata[item.product_id]
      const is_fr = this.$store.state.lang === 'fr'
      for (let e of entries) {
        let found = false
        if (metadata) {
          for (let attr of metadata.attributes) {
            if (e[0] === attr.key) {
              if (attr.type === 'options') {
                for (let opt of attr.value) {
                  found = true
                  out[is_fr ? attr.title_fr : attr.title_en] = e[1]
                  if (opt.key === e[1]) {
                    out[is_fr ? attr.title_fr : attr.title_en] = is_fr ? opt.fr : opt.en
                    break
                  }
                }
              } else {
                out[is_fr ? attr.title_fr : attr.title_en] = e[1]
                found = true
              }
            }
          }
        }
        if (!found) {
          out[e[0]] = e[1]
        }
      }
      return out
    },
    items_are_equal(a, b) {
      // checks if the IDs are the same, and applicable props are the same (everything except cart token)
      if (a.id === b.id) {
        const a_props = Object.fromEntries(Object.entries(a.properties || {}).filter(e => e[0] !== '_cart_token'))
        const b_props = Object.fromEntries(Object.entries(b.properties || {}).filter(e => e[0] !== '_cart_token'))
        return objectsAreEqual(a_props, b_props)
      }
      return false
    },
    create_cart_copy() {
      let out = {}
      for (let item of this.cart.items) {
        out[item.key] = {
          variant_id: item.variant_id,
          properties: Object.assign({}, item.properties),
          quantity: item.quantity
        }
      }
      return out
    },
    get_cart_tags_and_metafields() {
      const pids = []
      for (let item of this.cart.items) {
        if (!pids.includes(item.product_id)) {
          pids.push(item.product_id)
        }
      }
      if (pids.length > 0) {
        axios.post(`${storefront.url}/api/2024-04/graphql.json`,
            {
              query: `query ($shopify_ids: [ID!]!) {
                        nodes(ids: $shopify_ids) {
                          ... on Product {
                            id
                            tags
                            custom_metadata: metafield(namespace: "details", key: "custom_metadata") {
                              value
                            }
                            pre_order: metafield(namespace: "details", key: "pre-order") {
                              value
                            }
                          }
                        }
                      }`,
              variables: {
                shopify_ids: pids.map(e => {
                  return `gid://shopify/Product/${e}`
                })
              }
            },
            {headers: {"X-Shopify-Storefront-Access-Token": storefront.token}})
        .then(
            resp => {
              if (resp.data.data && resp.data.data.nodes) {
                let clearance = {}
                let final_sale = {}
                let custom_metadata = {}
                let pre_orders = {}
                for (let node of resp.data.data.nodes) {
                  let sh_id = node.id.split("/").pop()
                  if (parseInt(sh_id)) {
                    clearance[parseInt(sh_id)] = node.tags.includes("clearance")
                    final_sale[parseInt(sh_id)] = node.tags.includes("final-sale")
                    if (node.pre_order && node.pre_order.value) {
                      let d = new Date(node.pre_order.value + "T07:00:00Z")
                      if (d > new Date()) {
                        pre_orders[parseInt(sh_id)] = d
                      }
                    }
                    if (node.custom_metadata && node.custom_metadata.value) {
                      custom_metadata[parseInt(sh_id)] = JSON.parse(node.custom_metadata.value)
                    }
                  }
                }
                this.custom_metadata = custom_metadata
                this.clearance_items = clearance
                this.final_sale_items = final_sale
                this.pre_order_items = pre_orders
              }
            },
            err => {
              console.error("Error fetching cart tags:", err, err.response)
            }
        )
      }
    },
    setQuantityEdit(e) {
      e.preventDefault();
      this.cart_step = "quantity"
    },
    async setRoutingReview(e) {
      if (e !== null) {
        e.preventDefault();
      }
      this.pickup_shortcut = false
      this.cart_step = "routing"
      if (this.changes_made || !this.cart_tokens_set.valid || this.cart_tokens_set.invalid) {
        this.routing_loading = true
        // update cart and get new routing
        let changes = []
        let need_to_set_cart_token = !this.cart_tokens_set.valid
        let need_to_remove_old_cart_tokens = this.cart_tokens_set.invalid
        for (let item of this.cart.items) {
          if (!item.properties) {
            item.properties = {}
          }
          if (need_to_set_cart_token && item.quantity > 0) {
            item.properties._cart_token = this.initial_cart_token
            need_to_set_cart_token = false
          }
          if (need_to_remove_old_cart_tokens && item.properties._cart_token) {
            if (item.properties._cart_token !== this.initial_cart_token) {
              item.properties._cart_token = this.initial_cart_token
            }
          }
          if (item.key in this.original_cart) {
            let original = this.original_cart[item.key]
            // update if any fields changed
            if (original.quantity !== item.quantity
                || !this.items_are_equal(item.properties, original.properties || {})
                || item.properties._cart_token !== (original.properties || {})._cart_token) {
              changes.push({
                id: item.key,
                quantity: item.quantity,
                properties: Object.assign({}, item.properties)
              })
            }
          } else {
            throw new Error(`${item} does not exist in cart`)
          }
        }
        let last_response = null
        for (let change of changes) {
          try {
            last_response = await axios.post(`${this.$store.getters.locale_uri_prefix}/cart/change.js`, change)
          } catch (err) {
            this.routing_loading = false
            return this.raiseCartUpdateError(err)
          }
        }
        if (last_response !== null) {
          this.$store.commit({type: "setCart", value: last_response.data})
          this.original_cart = this.create_cart_copy()
          this.getRouting()
        }
        this.routing_loading = false
      }
    },
    raiseCartUpdateError(err) {
      console.error("error updating cart", err)
      this.cart_error = true
      this.$store.dispatch("getCart")
      this.cart_step = "quantity"
      let rq = document.getElementById("reviewQuantities")
      if (rq !== null) {
        rq.focus()
      }
    },
    openPickupModal(item) {
      let stock = (this.cart_stock.variants[item.sku] || {}).stock || {}
      this.$store.state.global_components.overlay.openModal({
        modal: 'pickup',
        stores: this.$store.getters.get_pickup_stores(stock),
        item: item,
      })
    },
    openReturnPolicyModal() {
      this.$store.state.global_components.overlay.openModal({
        modal: 'return-policy',
        src: undefined,
        alt: undefined
      });
    },
    routing_quantity_text(item) {
      if (item.quantity !== this.total_quantities[item.variant_id]) {
        return `${item.quantity}  (${this.$store.state.lang === 'fr' ? 'a' : 'of'} ${this.total_quantities[item.variant_id]})`
      }
      return item.quantity.toString()
    },
    removeItem(cart_item) {
      this.decItem(cart_item, cart_item.quantity);
      axios.post("/cart/change.js", {
        id: cart_item.key,
        quantity: 0
      }).then(
          resp => {
            this.$store.commit({type: "setCart", value: resp.data})
            this.original_cart = this.create_cart_copy()
            this.getRouting()
          },
          err => {
            this.raiseCartUpdateError(err)
          })
    },
    inputChange(cart_item, evt) {
      let qty = parseInt(evt.target.value)
      if (!isNaN(qty)) {
        if (qty > cart_item.quantity) {
          this.incItem(cart_item, qty - cart_item.quantity)
        } else if (qty < cart_item.quantity) {
          this.decItem(cart_item, cart_item.quantity - qty)
        } else {
          return
        }
        this.changes_made = true;
      }
    },
    incItem(cart_item, delta) {
      for (let i of this.cart.items) {
        if (this.items_are_equal(cart_item, i)) {
          i.quantity += delta
          this.changes_made = true;
          dataLayer.push({ecommerce: null});
          dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              'items': [{
                "item_id": cart_item.product_id,
                "item_name": cart_item.product_title,
                "item_brand": cart_item.vendor,
                "item_category": cart_item.product_type,
                "quantity": delta,
                "price": Math.round(cart_item.final_price + Number.EPSILON) / 100,
                "discount": (cart_item.compare_at_price ?
                    Math.round(cart_item.compare_at_price - cart_item.final_price + Number.EPSILON) / 100 : 0),
                "currency": this.$store.state.country === 'US' ? 'USD' : 'CAD',
                "item_variant": cart_item.variant_title
              }]
            }
          });
          return
        }
      }
    },
    decItem(cart_item, delta) {
      for (let i of this.cart.items) {
        if (this.items_are_equal(cart_item, i)) {
          i.quantity -= delta
          this.changes_made = true;
          dataLayer.push({ecommerce: null});
          dataLayer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
              'items': [{
                "item_id": cart_item.product_id,
                "item_name": cart_item.product_title,
                "item_list_name": "cart",
                "item_brand": cart_item.vendor,
                "item_category": cart_item.product_type,
                "quantity": delta,
                "price": Math.round(cart_item.final_price + Number.EPSILON) / 100,
                "discount": (cart_item.compare_at_price ?
                    Math.round(cart_item.compare_at_price - cart_item.final_price + Number.EPSILON) / 100 : 0),
                "currency": this.$store.state.country === 'US' ? 'USD' : 'CAD',
                "item_variant": cart_item.variant_title
              }]
            }
          });
          return
        }
      }
    },
    createRoutingSplits(routing) {
      // renders the shipments for the "Review Shipping" page - requires a valid routing object
      let routed_quantities = routing.routing

      let pickup_items = {}
      let fulfillment_items = {}
      this.cart.items.forEach(item => {
        if (item.properties && item.properties._store_for_pickup) {
          if (!(item.properties._store_for_pickup in pickup_items)) {
            pickup_items[item.properties._store_for_pickup] = []
          }
          pickup_items[item.properties._store_for_pickup].push(item)
        } else {
          let upc = parseInt(item.sku)
          for (let store of Object.keys(routed_quantities.fulfillment)) {
            if (routed_quantities.fulfillment[store].includes(upc)) {
              if (!(store in fulfillment_items)) {
                fulfillment_items[store] = []
              }
              let routed_count = routed_quantities.fulfillment[store].reduce((acc, cur) => {
                return acc + (cur === upc ? 1 : 0)
              }, 0)
              if (routed_count < item.quantity) {
                // split the item and decrement the original item
                let item2 = Object.assign({}, item)
                item2.quantity = routed_count

                item = Object.assign({}, item)
                item.quantity -= routed_count
                fulfillment_items[store].push(item2)
              } else {
                fulfillment_items[store].push(item)
                let remaining = parseInt(item.quantity)
                routed_quantities.fulfillment[store] = routed_quantities.fulfillment[store].filter(e => {
                  if (e === upc) {
                    if (remaining > 0) {
                      remaining -= 1;
                      return false
                    }
                  }
                  return true
                })
              }
            }
          }
        }
      });

      this.routed_cart = []
      for (let store_number of Object.keys(pickup_items)) {
        this.routed_cart.push({
          type: 'pickup',
          store_number: store_number,
          store_info: this.$store.getters.store_info(store_number),
          shipping_cost: 0,
          items: pickup_items[store_number].map(item => {
            let item_subtotal = item.quantity * item.original_price;
            item.price = this.$store.getters.currency(item.price);
            item.final_line_price = this.$store.getters.currency(item_subtotal);
            return item;
          })
        })
      }

      // get the shipping rates for fulfillment routings
      let routed_rates = {}
      for (let rate of routing.rates) {
        if (rate.packages.length > 0) {
          routed_rates[rate.origin_store] = {
            shipping_cost: rate.shipping_cost,
            shipping_discount: rate.customer_shipping_discount,
            customer_pays: (rate.shipping_cost || 0) - (rate.customer_shipping_discount || 0),
            ship_estimate_days: rate.ship_estimate_days
          }
        }
      }
      for (let store_number of Object.keys(fulfillment_items)) {
        let rates = routed_rates[store_number] || {}
        const s = {
          type: 'fulfillment',
          store_number: store_number,
          store_info: this.$store.getters.store_info(store_number),
          shipping_cost: rates.customer_pays * 100,
          ship_estimate_days: null,
          shipping_cost_money: this.$store.getters.currency(rates.customer_pays * 100),
          items: fulfillment_items[store_number].map(item => {
            let item_subtotal = item.quantity * item.original_price;
            item.price = this.$store.getters.currency(item.price);
            item.final_line_price = this.$store.getters.currency(item_subtotal);
            return item;
          })
        }
        s.ship_estimate_days = this.daysFromDate(rates.ship_estimate_days, this.check_pre_order_date(s))
        this.routed_cart.push(s)
      }
    },
    getRouting() {
      this.routing_loading = true;
      this.postal_code_edit = false;

      let payload = {
        fulfillment: [],
        pickup: [],
        postal_code: this.postal_code,
        cart_token: this.cart.token,
      };

      this.cart.items.forEach(item => {
        if (item.quantity > 0) {
          if (item.properties && item.properties._store_for_pickup) {
            payload.pickup.push([parseInt(item.sku), item.quantity, parseInt(item.properties._store_for_pickup)]);
          } else {
            payload.fulfillment.push([parseInt(item.sku), item.quantity]);
          }
        }
      });

      this.original_cart = this.create_cart_copy()
      this.changes_made = false;
      this.stock_error = false
      this.shipping = null
      this.shipping_credit = null

      if (this.cart.items.length > 0) {
        axios.post('/apps/api/routing', payload).then(
            response => {
              this.routing_loading = false
              this.shipping = 0;
              this.shipping_credit = 0;
              this.location_error = false
              this.stock_error = false
              this.geocoding_error = false
              this.outside_canada_error = false
              this.cart_error = false
              if (response.data.rates && response.data.rates.error &&
                  response.data.rates.error === 'cannot ship outside of Canada') {
                this.location_error = true
              } else {
                response.data.rates.forEach(rate => {
                  rate.packages.forEach(pkg => {
                    this.shipping += pkg.rate * 100;
                  })
                  this.shipping_credit += rate.customer_shipping_discount * 100;
                });
                this.createRoutingSplits(response.data)
                this.view_cart_datalayer()
              }
            },
            error => {
              this.routing_loading = false
              this.cart_step = "quantity"
              let rq = document.getElementById("reviewQuantities")
              if (rq !== null) {
                rq.focus()
              }
              if (error.response && error.response.data.error === "quantities in cart are greater than can be fulfilled") {
                this.stock_error = true
              } else if (error.response && error.response.data.error === 'could not geocode postal code') {
                this.geocoding_error = true;
                this.cart_error = true;
              } else if (error.response && error.response.data.error === 'cannot ship outside of Canada') {
                this.outside_canada_error = true;
                this.cart_error = true;
              }
            }
        );
      }
    },
    daysFromDate(days, start_date) {
      if (!days) {
        return null
      }
      let date = start_date ? new Date(start_date) :  new Date();
      let startDate = date.setDate(date.getDate() + days[0]);
      let endDate = date.setDate(date.getDate() + days[1]);
      return `${format_date(new Date(startDate), this.$store.state.lang)} - ${format_date(new Date(endDate), this.$store.state.lang)}`;
    },
    togglePickup(cart_item_key, store_number) {
      let variant_id = null
      let target_line = null
      const target_props = store_number ? {_store_for_pickup: store_number} : {}
      for (let cart_line of this.cart.items) {
        if (cart_item_key === cart_line.key) {
          variant_id = cart_line.variant_id
          target_line = cart_line
          break
        }
      }
      if (target_line === null) {
        console.error(`Cart Item ${cart_item_key} not found`)
        return
      }

      this.pickup_shortcut = false
      this.changes_made = true

      // check if there is an existing line we can increment/decrement first
      for (let cart_line of this.cart.items) {
        if (cart_line.variant_id === variant_id && this.items_are_equal(cart_line.properties || {}, target_props)) {
          this.incItem(cart_line, target_line.quantity)
          this.decItem(target_line, target_line.quantity)
          return
        }
      }

      // otherwise flip properties
      target_line.properties = target_props
    },
    togglePostalCodeEdit: function () {
      this.postal_code_edit = !this.postal_code_edit;
    },
    view_cart_datalayer() {
      dataLayer.push({ecommerce: null})
      dataLayer.push({
        "event": "view_cart",
        "ecommerce": {
          "currency": this.$store.state.country === "US" ? "USD" : "CAD",
          "value": (this.subtotal + this.shipping - this.shipping_credit) / 100,
          "shipping": (this.shipping - this.shipping_credit) / 100,
          "items": this.cart.items.map(e => {
            return {
              "item_id": e.id,
              "item_name": e.product_title,
              "item_variant": e.variant_title,
              "item_brand": e.vendor,
              "item_category": e.product_type,
              "quantity": e.quantity,
              "price": e.original_price / 100,
              "discount": (e.original_price - e.final_price) / 100,
              "currency": this.$store.state.country === 'US' ? 'USD' : 'CAD',
              "location_id": (e.properties || {})._store_for_pickup || 0
            }
          })
        }
      })
    }
  },
  mounted() {
    this.$store.dispatch('getLocation').then(resp => {
      this.postal_code = this.$store.state.location.postal_code
    }, () => {
    })

    this.$store.dispatch('getCart').then(
        resp => {
          this.original_cart = this.create_cart_copy()
          for (let shipment of this.quantity_cart) {
            if (shipment.type === 'fulfillment') {
              this.pickup_shortcut = false
            }
          }
          this.initial_cart_token = this.cart.token.split('?')[0]

          if (this.cart.item_count > 0) {
            this.get_cart_tags_and_metafields()
            let upcs = []
            this.cart.items.forEach(item => {
              let int = parseInt(item.sku)
              if (!upcs.includes(int)) {
                upcs.push(int)
              }
            })
            this.$store.dispatch('getLocation').then(
                resp2 => {
                  axios.get(`/apps/api/stock/variants?coords=${this.$store.getters.coords}&radius=-1&upcs=${upcs.join(",")}`)
                  .then(
                      response => {
                        this.cart_stock = response.data

                        // preload this assuming people won't adjust quantities
                        if (this.postal_code) {
                          this.getRouting();
                        }
                      },
                      error => {
                        console.error(error.response.data.error)
                      })
                },
                () => {
                })
            this.view_cart_datalayer()
          }
        },
        () => {
        })
  },
}